import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { TypedMemo } from '../../common/types';
import { SMLAnalytics } from './analytics';
import { useTrackingConsent } from '../consent/useTrackingConsent';

/**
 * Sends `screen_viewed` on every route change: a direct load, Back and Forward, a link and a
 * router push alike. The name is the route name (`screenOfPath`), never the path with its ids.
 */
const ScreenViewTrackerComponent: React.FC = () => {
  const { pathname } = useLocation();
  // The screen on view when the visitor accepts counts too.
  const granted = useTrackingConsent() === 'granted';
  const last = useRef<string | null>(null);

  useEffect(() => {
    const key = `${granted}:${pathname}`;
    if (last.current === key) {
      return;
    }
    last.current = key;
    SMLAnalytics.screenPath(pathname).catch(console.error);
  }, [pathname, granted]);

  return null;
};

export const ScreenViewTracker = TypedMemo(ScreenViewTrackerComponent);
